<template>
  <layout :drawer="false">

    <template slot="nav">
      <v-tabs>
        <v-tab>Natural Language Query</v-tab>
      </v-tabs>
    </template>

    <template slot="nav-tools">
      <smart-btn small @click.native="onNewNLQ" class="mr-4">
        <v-icon>mdi-new-box</v-icon>
      </smart-btn>
    </template>

    <template slot="content">
        <v-container fluid>
          <v-card fluid>
            <v-container class="list-container pa-4">
              <v-row>
                <v-col cols="12" >

                  <v-data-table
                      :headers="headers"
                      :items="nl_queries"
                      :sort-by="['status', 'startDate']"
                      :sort-desc="[false, true]"
                      :disable-pagination="true"
                      :hide-default-footer="true"
                      class="elevation-1 tbl"
                      no-data-text="Aucune query."
                      @click:row="openNlQuery"
                      :loading="loading"
                  >
                    <template #item.createdAt="{ value }">
                      <div v-if="value" class="d-flex items-center">
                        <span class="mr-2">{{ _convertDay(value) }}</span>
                        <span class="caption grey--text">{{ _convertHour(value) }}</span>
                      </div>
                    </template>
                    <template #item.status="{ item }">
                      <NlQueryStatusChip x-small :value="item.status" />
                    </template>
                    <template #item.actions="{item}">
                      <v-row no-gutters justify="end" class="pr-6">
                        <v-icon small class="" @click.stop="onDelete(item)">delete</v-icon>
                      </v-row>
                    </template>
                  </v-data-table>
                </v-col>

              </v-row>
            </v-container>
          </v-card>
        </v-container>
    </template>
  </layout>
</template>

<script>
import Layout from "@/views/Layout.vue";
import {get, post} from "@/utils/api";
import NlQueryStatusChip from "@/components/commons/NlQueryStatusChip.vue";


export default {
  name: "NaturalLanguageQueryView",
  components: { NlQueryStatusChip, Layout },
  data: () => ({
    loading: false,
    headers: [
      { text:"ID", value:"id"},
      { text:"PROMPT", value:"prompt"},
      { text:"STATUS", value:"status"},
      { text: "DATE DE CRÉATION", value: "createdAt", align: "left", sortable: true,
        sort: (a, b) => new Date(a) - new Date(b) },
      { text:"MODÈLE", value:"llmProvider", align: "center"},
      { text: "ACTIONS", value: "actions", align: "right" },
    ],
    nl_queries: [],
  }),
  created() {
    this.init();
  },
  watch: {},
  computed: {},
  methods: {
    init() {
      this.loading = true
      const url = "/api/db/query";

      get(url).json((r) => {
        this.nl_queries = r;

        this.loading = false
      });
    },
    onDelete(nlquery) {
      if (!nlquery || !nlquery.id) { return }
      const message = "Êtes-vous sûr de vouloir supprimer cette requête ?"
      const ids = [nlquery.id]
      this._confirmAndRun( message, () => this.deleteNlQueries(ids))
    },
    deleteNlQueries(ids) {
      const url = `/api/db/query/delete`
      post(url, ids).res(() => { this.init() });
    },
    openNlQuery(nlquery) {
      if(!nlquery) {
        this.init()
        return
      }
      this.$router.push({
        name: "NaturalLanguageQueryDetail",
        params: {
          id: String(nlquery.id),
          isNew: false
        }
      })
    },
    onNewNLQ() {
      this.$router.push({
        name: "NaturalLanguageQueryDetail",
        params: {
          id: "0",
          isNew: true
        }
      })
    }
  }// [N] end methods
}
</script>

<style scoped>
.list-container {
  display: flex;
  flex-direction: column;
}
</style>